import { ICatalogListingBookingApproverQuery } from '../interfaces/catalog-listing-booking-approver.query.interface';

export class CatalogListingBookingApprover {
    id: number;
    userId: number;
    fullName: string;
    imageUrl: string | null;
    status: string;
    comment: string | null;

    constructor(query: ICatalogListingBookingApproverQuery) {
        const user = query.user;

        this.id = query.id;
        this.userId = user.id;
        this.fullName = [user.first_name, user.last_name].filter((value) => !!value).join(' ') || user.email || '-';
        this.imageUrl = user.profile_picture?.thumb_url || user.profile_picture?.small_url || user.profile_picture?.url || null;
        this.status = query.status;
        this.comment = query.comment ?? null;
    }
}
